// @flow
import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import { hot } from 'react-hot-loader'

import Cover from '../cover'
import Profile from '../../components/profile'
import Waypoint from 'react-waypoint'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import Scrollchor from 'react-scrollchor'
import { FeedbackMessage } from '@ta-interaktiv/react-feedback-message'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'
import ThemeSwitch from '@ta-interaktiv/react-theme-switch'

import './styles.scss'

type Props = {
  articleId: string
}

const ADDITIONAL_SHARES = 394

class AppComponent extends React.Component<Props> {
  static defaultProps = {
    articleId: '28632492'
  }

  constructor(props) {
    super(props)
    this.trackNavClicks = this.trackNavClicks.bind(this)
    this.trackTopClicks = this.trackTopClicks.bind(this)
  }

  trackNavClicks(e) {
    let clickedText = e.currentTarget.firstChild.nodeValue
    /* console.log('target:' + clickedText) */
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'question: ' + clickedText
    })
  }

  trackTopClicks(e) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'toTop: '
    })
  }

  render() {
    return (
      <div className='index'>
        <ThemeSwitch />
        <Masthead
          inverted
          articleID={this.props.articleId}
          additionalShares={ADDITIONAL_SHARES}
        />
        <header className='ui vertical fitted segment first'>
          <Cover
            title='Das Rahmen&shy;abkommen erklärt'
            subtitle='Worüber streiten eigentlich die Schweiz und die EU?'
          />
        </header>

        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === 'below') {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'startReading'
              })
            }
          }}
        />

        <main className='ui vertical segment'>
          <div className='ui text container'>
            <p className='ta author'>
              Von Luca De Carli und Patrick Vögeli (Interaktiv-Team)
            </p>
            <p>
              Seit Ende 2018 liegt das zwischen der Schweiz und der EU
              ausgehandelte Rahmenabkommen auf dem Tisch. Die EU hatte erwartet,
              dass die Schweiz das Abkommen möglichst rasch unterzeichnet und
              umsetzt. In der Schweiz kam jedoch sofort Kritik am
              Verhandlungsergebnis auf. Doch warum ist dieses Abkommen
              eigentlich so wichtig? Und wo liegen die grössten Differenzen
              zwischen der Schweiz und der EU? Nachfolgend finden Sie eine
              Zusammenstellung der wichtigsten Diskussionspunkte.
            </p>
          </div>

          <p className='spaced'>&nbsp;</p>
          <div className='ui text container'>
            <ul className='nav' id='nav'>
              <Scrollchor to='#question-1'>
                <li className='question-link' onClick={this.trackNavClicks}>
                  1. Das ist der aktuelle Stand beim Rahmenabkommen
                </li>
              </Scrollchor>
              <Scrollchor to='#question-2'>
                <li className='question-link' onClick={this.trackNavClicks}>
                  2. Warum wurde überhaupt über ein Rahmenabkommen verhandelt?
                </li>
              </Scrollchor>
              <Scrollchor to='#question-3'>
                <li className='question-link' onClick={this.trackNavClicks}>
                  3. Das steht im Vertrag
                </li>
              </Scrollchor>
              <Scrollchor to='#question-4'>
                <li className='question-link' onClick={this.trackNavClicks}>
                  4. Das wurde im Vertrag weggelassen
                </li>
              </Scrollchor>
              <Scrollchor to='#question-5'>
                <li className='question-link' onClick={this.trackNavClicks}>
                  5. Wo die EU der Schweiz Zugeständnisse gemacht hat
                </li>
              </Scrollchor>
              <Scrollchor to='#question-6'>
                <li className='question-link' onClick={this.trackNavClicks}>
                  6. Was passiert, wenn die Schweiz und die EU sich nicht
                  einigen können?
                </li>
              </Scrollchor>
            </ul>
            <div className='mobile hidden'>
              <FeedbackMessage
                mailTo='interaktiv@tamedia.ch'
                question='Haben Sie Anmerkungen oder einen Fehler entdeckt? Oder blieb eine Frage unbeantwortet?'
              />
            </div>
          </div>

          <div
            className='ui question container'
            id='question-1'
            style={{ textAlign: 'left' }}
          >
            <h2>
              <span className='title-text'>
                1. Das ist der aktuelle Stand beim Rahmenabkommen
              </span>
              <Scrollchor to='#nav'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div className='arrow-text'>nach oben</div>{' '}
                  <i className='chevron up icon' />
                </div>
              </Scrollchor>
            </h2>
          </div>
          <div className='ui text container'>
            <div class='ui two column grid stackable'>
              <div class='column'>
                <div class='ui fluid image bullet'>
                  <div class='image' style={{ backgroundColor: 'white' }}>
                    <img
                      src={require('./imgs/icon_verhandlungszeit.svg')}
                      alt=''
                      style={{
                        maxWidth: '80px',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                      }}
                    />
                  </div>
                  <div class='content'>
                    <div class='description'>
                      <span class='bold red mobile hidden'>1. </span>Die Schweiz
                      und die EU haben über vier Jahre lang verhandelt.
                    </div>
                  </div>
                </div>
              </div>

              <div class='column'>
                <div class='ui fluid image bullet'>
                  <div class='image' style={{ backgroundColor: 'white' }}>
                    <img
                      src={require('./imgs/icon_entwurf.svg')}
                      alt=''
                      style={{
                        maxWidth: '80px',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                      }}
                    />
                  </div>
                  <div class='content'>
                    <div class='description'>
                      <span class='bold red mobile hidden'>2. </span>Seit
                      Dezember 2018 liegt der Entwurf für ein Rahmenabkommen
                      vor.
                    </div>
                  </div>
                </div>
              </div>

              <div class='column'>
                <div class='ui fluid image bullet'>
                  <div class='image' style={{ backgroundColor: 'white' }}>
                    <img
                      src={require('./imgs/icon_endgueltig.svg')}
                      alt=''
                      style={{
                        maxWidth: '80px',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                      }}
                    />
                  </div>
                  <div class='content'>
                    <div class='description'>
                      <span class='bold red mobile hidden'>3. </span>Für die EU
                      ist das Verhandlungsergebnis offiziell endgültig.
                      Anzeichen, dass sie von diesem Kurs abweichen könnte, gibt
                      es bislang keine.
                    </div>
                  </div>
                </div>
              </div>

              <div class='column'>
                <div class='ui fluid image bullet'>
                  <div
                    class='image bullet'
                    style={{ backgroundColor: 'white' }}
                  >
                    <img
                      src={require('./imgs/icon_bundesrat.svg')}
                      alt=''
                      style={{
                        maxWidth: '80px',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                      }}
                    />
                  </div>
                  <div class='content'>
                    <div class='description'>
                      <span class='bold red mobile hidden'>4. </span>
                      Der Bundesrat hat im Dezember 2018 darauf verzichtet,
                      einen Entscheid zum Abkommen zu fällen.
                    </div>
                  </div>
                </div>
              </div>

              <div class='column'>
                <div class='ui fluid image bullet'>
                  <div
                    class='image bullet'
                    style={{ backgroundColor: 'white' }}
                  >
                    <img
                      src={require('./imgs/icon_konsultation.svg')}
                      alt=''
                      style={{
                        maxWidth: '80px',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                      }}
                    />
                  </div>
                  <div class='content'>
                    <div class='description'>
                      <span class='bold red mobile hidden'>5. </span>
                      Stattdessen führte der Bundesrat bei Parteien und
                      Verbänden eine Konsultation zum Abkommen durch. Die
                      Antworten fielen mehrheitlich negativ aus. Vom Bundesrat
                      werden Nachver&shy;handlungen mit der EU erwartet.
                    </div>
                  </div>
                </div>
              </div>

              <div class='column'>
                <div class='ui fluid image bullet'>
                  <div
                    class='image bullet'
                    style={{ backgroundColor: 'white' }}
                  >
                    <img
                      src={require('./imgs/icon_konsultation_bundesrat.svg')}
                      alt=''
                      style={{
                        maxWidth: '80px',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                      }}
                    />
                  </div>
                  <div class='content'>
                    <div class='description'>
                      <span class='bold red mobile hidden'>6. </span>
                      Nach dem Abschluss der Konsultation hat der Bundesrat
                      entschieden, dass er mit der EU über drei Aspekte des
                      Abkommens nochmals verhandeln will. Gemäss der EU ist das
                      Fenster für eine Unterzeichnung des Abkommens noch bis
                      Ende Oktober offen.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <p className='spaced'>&nbsp;</p>
            <div className='mobile only'>
              <FeedbackMessage
                mailTo='interaktiv@tamedia.ch'
                question='Haben Sie Anmerkungen oder einen Fehler entdeckt? Oder blieb eine Frage unbeantwortet?'
              />
            </div>
          </div>

          <div
            className='ui question container'
            id='question-2'
            style={{ textAlign: 'left' }}
          >
            <h2>
              <span className='title-text'>
                2. Warum wurde überhaupt über ein Rahmenabkommen verhandelt?
              </span>
              <Scrollchor to='#nav'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div className='arrow-text'>nach oben</div>{' '}
                  <i className='chevron up icon' />
                </div>
              </Scrollchor>
            </h2>
          </div>
          <div className='ui text container'>
            <p>
              Der Ausbau der bilateralen Beziehungen zwischen der Schweiz und
              der EU ist seit mehreren Jahren blockiert. Dies, obwohl
              insbesondere die Schweiz am Abschluss von zusätzlichen Abkommen
              interessiert ist, die ihren Zugang zum europäischen Markt sichern
              und ausweiten. Der Grund: Ende 2012 haben die EU-Länder
              entschieden, dass es solche Marktzugangsabkommen mit der Schweiz
              nicht mehr geben wird – ausser die beiden Seiten einigen sich auf
              ein Rahmenabkommen.
            </p>
            <p>
              Aus Sicht der EU ist es ein Problem, dass es zwischen den meist
              statischen bilateralen Verträgen mit der Schweiz und dem sich
              ständig weiterentwickelnden Recht innerhalb der Union immer
              grössere Differenzen gibt. Das Rahmenabkommen soll deshalb regeln,
              ob und wie die Schweiz künftig neues EU-Recht übernimmt. Und vor
              allem, wer entscheidet, wenn sich die beiden Seiten bei der
              Übernahme von neuem Recht oder der Auslegung von bestehenden
              Abkommen nicht einig sind.
            </p>

            <p className='spaced'>&nbsp;</p>
            <h5>Der bilaterale Weg der Schweiz</h5>

            <ul className='timeline'>
              <li>
                <h4>
                  <i className='circle icon' /> 1972 Die Basis
                </h4>
                <p>
                  Die Grundlage für den wirtschaftlichen Austausch zwischen der
                  Schweiz und der EU bildet das{' '}
                  <span className='underline red'>Freihandelsabkommen</span> von
                  1972. Es wurde damals an der Urne mit 72,5 Prozent angenommen.
                  1989 folgten das Versicherungsabkommen und 1990 das
                  Güterverkehrsabkommen.
                </p>
              </li>

              <li>
                <h4>
                  <i className='circle icon' /> 1992 Die Krise
                </h4>
                <p>
                  Der Beitritt der Schweiz zum Europäischen Wirtschaftsraum
                  (EWR) wird 1992 vom Volk knapp mit 50,3 Prozent abgelehnt.
                  Dieser Schritt hätte die Schweiz auf einen Schlag in den
                  EU-Binnenmarkt integrieren sollen.
                </p>
              </li>

              <li>
                <h4>
                  <i className='circle icon' /> 1999 Der Weg aus der Krise
                </h4>
                <p>
                  Nach dem Nein zum EWR-Beitritt verhandelte die EU mit der
                  Schweiz über Marktzugangsabkommen in mehreren Bereichen –
                  unter anderem über die Personenfreizügigkeit und den
                  Landverkehr. Dieses Paket, die{' '}
                  <span className='underline red'>Bilateralen I</span>, wurde
                  1999 unterzeichnet und vom Volk mit 67,2 Prozent Ja-Stimmen
                  gutgeheissen.
                </p>
              </li>

              <li>
                <h4>
                  <i className='circle icon' /> 2004 Update
                </h4>
                <p>
                  Unterzeichnung der{' '}
                  <span className='underline red'>Bilateralen II</span>. Diesmal
                  ging es neben der wirtschaftlichen Zusammenarbeit erstmals
                  auch um andere Bereiche. Insbesondere um die Zusammenarbeit in
                  Sicherheits- und Asyl-Fragen (Schengen-/Dublin-Abkommen). Das
                  Volk stimmte dem mit 54,6 Prozent zu.
                </p>
              </li>

              <li>
                <h4>
                  <i className='circle icon' /> 2014 Stillstand
                </h4>
                <p>
                  Start der Verhandlungen zum Rahmenabkommen. Im Dezember 2018
                  veröffentlichte der Bundesrat das Ergebnis. Aus Sicht der EU
                  sind die Verhandlungen abgeschlossen.
                </p>
              </li>
            </ul>
          </div>

          <div
            className='ui question container'
            id='question-3'
            style={{ textAlign: 'left' }}
          >
            <h2>
              <span className='title-text'>3. Das steht im Vertrag</span>
              <Scrollchor to='#nav'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div className='arrow-text'>nach oben</div>{' '}
                  <i className='chevron up icon' />
                </div>
              </Scrollchor>
            </h2>
          </div>
          <div className='ui text container'>
            <h4>Gültigkeitsbereich</h4>
            <p>
              Die Schweiz hat über 120 bilaterale Verträge mit der EU
              abgeschlossen. Das Rahmenabkommen betrifft aber nur fünf Verträge,
              die den Zugang der Schweiz zum europäischen Markt regeln: die
              Abkommen zur Personenfreizügigkeit, zum Landverkehr, zum
              Luftverkehr, zu den technischen Handelshemmnissen und zur
              Landwirtschaft. Ebenfalls unter das Abkommen fallen sollen alle
              künftigen Marktzugangsabkommen, etwa das schon lange geplante
              Stromabkommen.
            </p>
            <h4>Rechtsübernahme</h4>
            <p>
              Neues EU-Recht soll laut dem Rahmenabkommen rasch in die
              bilateralen Abkommen überführt und damit für die Schweiz
              verbindlich werden – spätestens innert drei Jahren. Diese
              Rechtsübernahme geschieht aber nicht automatisch. Parlament oder
              Volk können die Rechtsübernahme ablehnen. In solchen Fällen kann
              die EU das neue Streitbeilegungsverfahren einleiten.
            </p>
            <h4>Streitbeilegung</h4>
            <p>
              Zuerst können die EU oder die Schweiz den Gemischten Ausschuss
              anrufen – so wie bereits heute. Weil im Ausschuss beide Seiten
              gleichberechtigt vertreten sind, endet das aber oft in der
              Blockade. Um eine solche zu überwinden, können beide Seiten neu
              ein Schiedsgericht anrufen. Ist EU-Recht betroffen – wie fast
              immer bei den bilateralen Verträgen –, muss sich das
              Schiedsgericht jedoch an die Rechtssprechung des EU-Gerichtshofs
              halten. Wenn die Schweiz das Urteil des Schiedsgerichts nicht
              umsetzen will, kann die EU Strafmassnahmen einleiten. Das
              Schiedsgericht wacht darüber, dass die Retorsionsmassnahmen
              verhältnismässig sind.
            </p>
            <h4>Lohnschutz</h4>
            <p>
              Spätestens drei Jahre nach Inkrafttreten des Rahmenabkommens muss
              die Schweiz auch zwei neue EU-Richtlinien zur
              Personenfreizügigkeit übernehmen beziehungsweise in nationales
              Recht umsetzen: die Durchsetzungsrichtlinie von 2014 und die
              Entsenderichtlinie von 2018. Sie legen im Grundsatz fest, wie
              künftig die Löhne in der Schweiz geschützt werden. Damit kann die
              Schweiz ihre bisherigen flankierenden Massnahmen wohl nur noch
              teilweise aufrechterhalten. Die EU sichert der Schweiz jedoch
              schriftlich gewisse zusätzliche Lohnschutzmassnahmen zu, die über
              das derzeitige Schutzniveau in der EU hinausgehen.
            </p>
            <p>
              <a
                href='https://www.dfae.admin.ch/dam/dea/de/documents/abkommen/Acccord-inst-Projet-de-texte_de.pdf'
                target='_blank'
              >
                <i className='external icon' />
                Vertrag
              </a>
              <br />
              <a
                href='https://www.eda.admin.ch/dam/dea/de/documents/abkommen/InstA-Wichtigste-in-Kuerze_de.pdf'
                target='_blank'
              >
                <i className='external icon' />
                Zusammenfassung
              </a>
            </p>
            <div>
              <p className='graphic title lauftext'>
                <strong>
                  Die Netto-Zu-/Abwanderung in der Schweiz hat sich stabilisiert
                </strong>
                <p className='graphic subtitle'>In Tausend 1991–2018</p>
              </p>
              <p>
                <img
                  src={require('./imgs/netto_zu_abwanderung.svg')}
                  alt=''
                  className='ui fluid image'
                />
              </p>
              <p className='graphic text source'>
                Quelle: Seco (14. Bericht des Observatoriums zum
                Freizügigkeitsabkommen Schweiz-EU)
              </p>
            </div>
          </div>

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === 'below') {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: '50ContentRead'
                })
              }
            }}
          />

          <div
            className='ui question container'
            id='question-4'
            style={{ textAlign: 'left' }}
          >
            <h2>
              <span className='title-text'>
                4. Das wurde im Vertrag weggelassen
              </span>
              <Scrollchor to='#nav'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div className='arrow-text'>nach oben</div>{' '}
                  <i className='chevron up icon' />
                </div>
              </Scrollchor>
            </h2>
          </div>
          <div className='ui text container'>
            <p>
              Zwei entscheidende Aspekte werden weder im Rahmenabkommen noch in
              den Zusatzprotokollen geklärt:
            </p>

            <div className='ui grid icons'>
              <div className='ui centered column row first'>
                <div className='sixteen wide mobile four wide tablet four wide computer column'>
                  <img
                    src={require('./imgs/icon_unionsbuergerrichtlinie.svg')}
                    alt=''
                    className='ui fluid centered image iconRichtlinie'
                  />
                </div>

                <div className='sixteen wide mobile twelve wide tablet twelve wide computer column'>
                  <h4 className='icon title'>EU-Unionsbürgerrichtlinie</h4>
                  <p>
                    Dieser EU-Rechtstext ist aus Sicht der Schweiz
                    problematisch, da er die Sozialhilfeansprüche, den Schutz
                    vor Ausweisung sowie das Daueraufenthaltsrecht der EU-Bürger
                    ausweitet. Aus Sicht der EU gilt die Richtlinie auch für die
                    Schweiz. Im Vertragsentwurf wird sie aber nicht erwähnt.
                    Sollte es künftig wegen der Richtlinie Streit zwischen der
                    EU und der Schweiz geben, müsste das Schiedsgericht
                    angerufen werden. Die Schweiz wollte in den Verhandlungen
                    eigentlich erreichen, dass eine Übernahme der Richtlinie
                    explizit ausgeschlossen wird.
                  </p>
                </div>
              </div>
            </div>

            <div className='ui grid icons'>
              <div className='ui centered column row'>
                <div className='sixteen wide mobile four wide tablet four wide computer column'>
                  <img
                    src={require('./imgs/icon_sozialversicherungen.svg')}
                    alt=''
                    className='ui fluid centered image iconSozial'
                  />
                </div>

                <div className='sixteen wide mobile twelve wide tablet twelve wide computer column'>
                  <h4 className='icon title'>Sozialversicherungen</h4>
                  <p>
                    Wird ein Grenzgänger arbeitslos, kommt bislang die
                    Arbeitslosenversicherung seines Heimatlandes für ihn auf –
                    obwohl die Grenzgänger in das Schweizer Sozialsystem
                    einbezahlt haben. Das wird heute durch einen Beitrag der
                    Schweiz an die Nachbarstaaten nur teilweise kompensiert. Die
                    EU plant eigentlich einen Systemwechsel: Neu soll das
                    Arbeitsland zuständig sein. Der Systemwechsel ist im
                    Frühjahr aber vorerst gescheitert. Die Mitgliedsstaaten
                    konnten sich nicht einigen. Vom Tisch ist die Reform damit
                    aber nicht. Der Systemwechsel findet im Rahmenabkommen keine
                    Erwähnung. Künftig müsste die Schweiz jedoch Änderungen bei
                    der sozialen Koordination genauso dynamisch übernehmen wie
                    andere Rechtsänderungen. Der Wechsel wäre für die Schweiz
                    teuer. Die Rede ist von Zusatzkosten für die
                    Arbeitslosenversicherung von mehreren Hundert Millionen
                    Franken pro Jahr.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div
            className='ui question container'
            id='question-5'
            style={{ textAlign: 'left' }}
          >
            <h2>
              <span className='title-text'>
                5. Wo die EU der Schweiz Zugeständnisse gemacht hat
              </span>
              <Scrollchor to='#nav'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div className='arrow-text'>nach oben</div>{' '}
                  <i className='chevron up icon' />
                </div>
              </Scrollchor>
            </h2>
          </div>
          <div className='ui text container'>
            <Profile
              avatarSrc={require('./imgs/ignazio_cassis.jpg')}
              name='Ignazio Cassis'
              byline='Aussenminister'
            >
              «Das ausgehandelte Rahmenabkommen entspricht zu 80 Prozent dem,
              was sich die Schweiz gewünscht hat.»
            </Profile>

            <p>
              Tatsächlich ist die EU der Schweiz in mehreren Punkten
              entgegengekommen:
            </p>
            <h4>Gültigkeit</h4>
            <p>
              Lange war von einem umfassenden Rahmenabkommen die Rede.
              Ausgehandelt wurde nun aber, dass es nur fünf bestehende
              Marktzugangsabkommen (Personenfreizügigkeit, Landverkehr,
              Luftverkehr, technische Handelshemmnisse und Landwirtschaft) und
              alle künftigen Abkommen betrifft. Insbesondere das
              Freihandelsabkommen von 1972 hätte die EU auch gerne einbezogen.
              Das Rahmenabkommen enthält jedoch nur eine Absichtserklärung zu
              einer späteren Modernisierung des Freihandelsabkommens. Experten
              streiten darüber, wie verbindlich diese Erklärung ist. Die Kantone
              befürchten, dass nach einer Modernisierung die sogenannten
              staatlichen Beihilfen unter Druck kommen. Gemeint sind damit zum
              Beispiel die Staatsgarantien für die Kantonalbanken.
            </p>
            <h4>Streitbeilegung</h4>
            <p>
              Vor den sogenannten fremden Richtern wurde im Zusammenhang mit dem
              Rahmenabkommen während Jahren gewarnt. Direkt bekommt es die
              Schweiz mit diesen gemäss dem ausgehandelten Abkommen nicht zu
              tun. Streitfragen werden nicht vom Europäischen Gerichtshof
              entschieden, sondern von einem Schiedsgericht. Dieses hat drei
              oder fünf Mitglieder; die EU und die Schweiz delegieren je einen
              bzw. zwei Schiedsrichter, welche dann einen neutralen Präsidenten
              wählen. Weil sich das Schiedsgericht aber an der Rechtsprechung
              des Europäischen Gerichtshofs orientieren muss, ist dessen
              Einfluss dennoch gross. Gemäss Experten entscheidet der
              Gerichtshof aber durchaus unabhängig von der EU. &nbsp;
              <a
                href='https://www.tagesanzeiger.ch/schweiz/standard/Fremden-Richtern-auf-die-Finger-geschaut/story/22734997'
                target='_blank'
              >
                <i className='external icon' />
                Mehr dazu lesen Sie hier.
              </a>
            </p>
            <h4>Lohnschutz</h4>
            <p>
              Einige flankierende Massnahmen gegen Tieflöhne aus der EU sind in
              einem Zusatzprotokoll zum Rahmenabkommen erstmals vertraglich
              abgesichert, allerdings in abgeschwächter Form. Neu sollen sich
              zum Beispiel entsandte EU-Arbeiter nur noch vier Werktage im
              Voraus anmelden; heute beträgt die Voranmeldefrist acht
              Kalendertage (entspricht in der Regel sechs Werktagen). Kautionen
              darf die Schweiz künftig nur noch von Firmen verlangen, welche
              frühere Bussen nicht bezahlt haben. Zudem sollen die Kontrollen
              zur Umsetzung der flankierenden Massnahmen nur noch
              «risikobasiert» in besonders gefährdeten Branchen stattfinden.
              Diese Einschränkungen sind der Hauptgrund für die Kritik in der
              Schweiz am ausgehandelten Abkommen.
            </p>
          </div>

          <div
            className='ui question container'
            id='question-6'
            style={{ textAlign: 'left' }}
          >
            <h2>
              <span className='title-text'>
                6. Was passiert, wenn die Schweiz und die EU sich nicht einigen
                können?
              </span>
              <Scrollchor to='#nav'>
                <div className='top-link' onClick={this.trackTopClicks}>
                  <div className='arrow-text'>nach oben</div>{' '}
                  <i className='chevron up icon' />
                </div>
              </Scrollchor>
            </h2>
          </div>
          <div className='ui text container'>
            <div>
              <p className='graphic title'>
                <strong>Warenverkehr zwischen der Schweiz und der EU</strong>
                <p className='graphic subtitle'>In Franken, 2017</p>
              </p>
              <p>
                <img
                  src={require('./imgs/grafik_handel.svg')}
                  alt=''
                  className='ui fluid image'
                />
              </p>
              <p className='graphic text source'>
                Quelle: Eidgenössische Zollverwaltung, Swiss-Impex
              </p>
            </div>
            <p>
              Pro Tag handeln die Schweiz und die EU mit Gütern im Wert von über
              einer halben Milliarde Franken. Die Hälfte aller Exporte der
              Schweiz geht in die EU. 2017 waren es Waren im Wert von 117
              Milliarden Franken. Mit Importen im Wert von 132 Milliarden
              Franken ist die Schweiz allerdings auch der drittwichtigste
              Handelspartner der EU – nach den USA und China.
            </p>
            <div>
              <p className='graphic title lauftext'>
                <strong>Dreimal so viele EU-Bürger in der Schweiz</strong>
                <p className='graphic subtitle'>
                  Ständige Aufenthalter in der Schweiz und der EU, 2017
                </p>
              </p>
              <p>
                <img
                  src={require('./imgs/grafik_migration.svg')}
                  alt=''
                  className='ui fluid image'
                />
              </p>
              <p className='graphic text source'>
                Quelle: Bundesamt für Statistik
              </p>
            </div>

            <p>
              300'000 Grenzgänger pendeln von ihrem Wohnsitz in der EU an ihren
              Arbeitsplatz in der Schweiz. 1,4 Millionen EU-Bürger haben sich
              ständig in der Schweiz niedergelassen, genauso wie 450'000
              Schweizer in der EU. Diese Zahlen zeigen, dass eine
              Verschlechterung des Verhältnisses zwischen der Schweiz und der
              Union sehr grosse Auswirkungen haben kann.
            </p>

            <p>
              Sollten sich die Schweiz und die EU nicht auf das ausgehandelte
              Rahmenabkommen einigen können und die EU auch weitere oder neue
              Verhandlungen verweigern, sind grundsätzlich{' '}
              <span className='underline red'>zwei Szenarien</span> denkbar:
            </p>

            <ol className='simple-list'>
              <li>
                <p className='graphic title list'>
                  <strong>
                    Die EU bleibt passiv, die bilaterale Beziehung erodiert
                    langsam
                  </strong>
                </p>
                <p>
                  Klar ist für die EU schon lange, ohne Rahmenabkommen gibt es
                  keine neuen Marktzugangsabkommen für die Schweiz. Auch die
                  Anpassung bestehender Abkommen wird laut der EU-Kommission
                  nicht mehr möglich sein. Das trifft vor allem das Abkommen
                  über technische Handelshemmnisse, das 20 Produktebereiche
                  abdeckt und regelmässig aktualisiert werden muss. Aktuell
                  steht eine Anpassung bei den Medizinalgeräten an. Ohne
                  Aktualisierung müssen Firmen beim Export in die EU zusätzliche
                  Kontrollen durchführen lassen, was Zeit und Geld kostet.
                  Fazit: Tut die EU einfach nichts, verschlechtert sich der
                  Zugang der Schweiz zu ihrem wichtigsten Exportmarkt laufend.
                </p>
              </li>
              <li>
                <p className='graphic title list'>
                  <strong>Die EU lanciert Gegenmassnahmen</strong>
                </p>
                <p>
                  Brüssel hat theoretisch diverse Möglichkeiten, um gezielt
                  gegen die Schweiz vorzugehen – auch in Bereichen, die nicht
                  direkt mit dem Rahmenabkommen zu tun haben. Ein Papier aus der
                  Bundesverwaltung listet eine Reihe von möglichen Drohszenarien
                  auf. So könnte die Schweiz vom europäischen Forschungs- und
                  Innovationsprogramm Horizon ausgeschlossen werden. Bereits
                  gehandelt hat die EU bei der Äquivalenz, also die
                  Gleichwertigkeitsbescheinigung der Schweizer Börse. Sie wurde
                  Ende Juni nicht mehr verlängert. Geschadet hat das der Börse
                  bislang nicht. Trotzdem: Wenn die EU will, kann sie einen
                  Konflikt mit der Schweiz sehr schnell eskalieren lassen.
                </p>
              </li>
            </ol>
          </div>

          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              if (event.previousPosition === 'below') {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'contentBottom'
                })
              }
            }}
          />
        </main>

        <Footer
          articleId={this.props.articleId}
          additionalShares={ADDITIONAL_SHARES}
          questions={[
            'Wie informativ war der Beitrag?',
            'Finden Sie diese Art von Erklärformat nützlich?',
            'Wie gefällt Ihnen die Gestaltung?'
          ]}
          credits={[
            ['Text und Recherche', 'Luca De Carli'],
            [
              'Digitales Konzept, Programmierung und Grafiken',
              'Patrick Vögeli und Marc Brupbacher, Interaktiv-Team'
            ]
          ]}
        >
          <div className='ui container'>
            <h4 className='ui small infographic dividing header'>
              Unsere besten Artikel zum Rahmenabkommen
            </h4>
            <br />
          </div>
          <div className='ui container'>
            <ArticleTeasers
              numberOfCards='three'
              articleIds={[
                '23394277',
                '13573703',
                '15148882',
                '30746662',
                '22734997',
                '19756147',
                '24157806',
                '13578218',
                '11412401',
                '13393853'
              ]}
              additionalClasses='doubling stackable raised'
              style={{
                maxWidth: '100vw'
              }}
            />
            &nbsp;
          </div>
        </Footer>

        <Waypoint
          scrollableAncestor={window}
          onEnter={event => {
            if (event.previousPosition === 'below') {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'pageBottom'
              })
            }
          }}
        />
      </div>
    )
  }
}

export default hot(module)(AppComponent)
